import { FC, PropsWithChildren } from 'react';
import { useFormContext, FieldValues } from 'react-hook-form';
import { PrimaryButton, BUTTON_SIZES } from 'ui/button';
import { Modal, ModalFooter, ModalBody, ModalHeader, MODAL_SIZES, MODAL_VARIANTS } from 'ui/modal';
import { useModalsContext } from '../../../../contexts';

export const TEXT = {
  ID: 'sms-sender-modal',
  MESSAGE_TYPE: 'sms-sender-message-type-id',
  MESSAGE_TYPE_LABEL: 'Optional message type binding',
  MESSAGE_TYPE_DESCRIPTION:
    'When a user texts in to unsubscribe, if the number has a message type binding configured, then the user will be unsubscribed only from that message type, rather than all SMS channels.',
};

type Props = {
  confirmText: string;
  headerText: string;
  onSubmit: (values: FieldValues) => void;
};

export const SmsSenderModalRHF: FC<PropsWithChildren<Props>> = ({
  confirmText,
  headerText,
  onSubmit,
  children,
}) => {
  const {
    handleSubmit,
    formState: { isValid },
  } = useFormContext();

  const { hideModal } = useModalsContext();

  return (
    <Modal
      id={TEXT.ID}
      isModalOpen={true}
      onClose={hideModal}
      size={MODAL_SIZES.MEDIUM}
      variant={MODAL_VARIANTS.DEFAULT}
    >
      <ModalHeader>{headerText}</ModalHeader>
      <ModalBody>{children}</ModalBody>
      <ModalFooter>
        <PrimaryButton
          isDisabled={!isValid}
          onClick={handleSubmit(onSubmit)}
          size={BUTTON_SIZES.LARGE}
        >
          {confirmText}
        </PrimaryButton>
      </ModalFooter>
    </Modal>
  );
};
